import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { Grid, InputLabel } from "@material-ui/core";

import { MiscellaneousIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { LabledTextField } from "../core/LabledTextField";

export const IncreaseExpectedElectricMiscellaneousForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_MISCELLANEOUS>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<MiscellaneousIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 8 }}>
                        Sonstige Verbraucher
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricMiscellaneous.value.installed}
                        {...getFieldProps("adjustableLoadElectricMiscellaneous.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricMiscellaneous.value.installed =
                                    checked;
                                values.increaseExpectedElectricMiscellaneous.value.description =
                                    checked ? "" : null;
                                values.increaseExpectedElectricMiscellaneous.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricMiscellaneous.value.installed}
                detail={
                    <Grid
                        container
                        spacing={4}
                        alignItems="flex-end"
                        style={{ paddingBottom: "12px" }}
                    >
                        <Grid item xs={12} md={8}>
                            <LabledTextField
                                label="Bezeichnung"
                                variant="outlined"
                                style={{ width: "100%" }}
                                placeholder="Motoren, Schweißgeräte, etc."
                                InputProps={{
                                    className: classes.textField,
                                    style: { width: "100%" },
                                    inputProps: {
                                        style: { fontFamily: "innogyWeb" },
                                    },
                                }}
                                inputProps={{
                                    maxLength: 100,
                                }}
                                value={
                                    values.increaseExpectedElectricMiscellaneous.value.description
                                }
                                onChange={(v) =>
                                    setValues((values) => {
                                        values.increaseExpectedElectricMiscellaneous.value.description =
                                            v.target.value;
                                    })
                                }
                                error={!!values.increaseExpectedElectricMiscellaneous.error}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputLabel className={classes.labledTextfieldLabel}>
                                Summe der Leistung
                            </InputLabel>
                            <NumberInput
                                className={classes.textField}
                                style={{ width: "100%" }}
                                fixedDecimalScale={false}
                                allowLeadingZeros={false}
                                decimalScale={
                                    values.increaseExpectedElectricMiscellaneous.value.demand
                                        .precision
                                }
                                isNumericString={false}
                                allowNegative={false}
                                thousandSeparator="."
                                decimalSeparator=","
                                adornment={
                                    values.increaseExpectedElectricMiscellaneous.value.demand.unit
                                }
                                value={
                                    values.increaseExpectedElectricMiscellaneous.value.demand
                                        .amount || ""
                                }
                                placeholder="0"
                                onValueChange={(v) =>
                                    setValues((values) => {
                                        values.increaseExpectedElectricMiscellaneous.value.demand.amount =
                                            v.floatValue || null;
                                    })
                                }
                                error={!!values.increaseExpectedElectricMiscellaneous.error}
                            />
                        </Grid>
                    </Grid>
                }
            />
        </Fragment>
    );
};
